import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import ILearn from "../molecules/ILearn";

class PreapprovalChecklistPage extends Component {
  render() {
    const content = contentMap.PreapprovalChecklistPage;
    const navigationsAway = customNavigationMap.PreapprovalChecklistPage;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />
            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              onPrimaryClick={() =>
                (window.location.href = "https://apply.clear.loans")
              }
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(PreapprovalChecklistPage);
